import React, {useState, useEffect, useContext, useRef} from "react";
import "./CommsCarousel.scss";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import {commsData} from "../../portfolio";

export default function CommsCarousel() {
  const {isDark} = useContext(StyleContext);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const touchStartX = useRef(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNextSlide = () => {
    setCurrentSlide(prevSlide => (prevSlide + 1) % commsData.talks.length);
  };

  const handlePrevSlide = () => {
    setCurrentSlide(
      prevSlide =>
        (prevSlide - 1 + commsData.talks.length) % commsData.talks.length
    );
  };

  const getOpacity = index => {
    if (isMobile) {
      return index === currentSlide ? 1 : 0;
    }
    if (index === currentSlide) return 1;
    if (
      index ===
        (currentSlide - 1 + commsData.talks.length) % commsData.talks.length ||
      index === (currentSlide + 1) % commsData.talks.length
    )
      return 0.4;
    return 0;
  };

  const getCardWidth = index => {
    if (isMobile) return index === currentSlide ? "100%" : undefined;
    return index === currentSlide ? "100%" : "10%";
  };

  const handleTouchStart = e => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = e => {
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (delta > 50) handlePrevSlide();
    else if (delta < -50) handleNextSlide();
  };

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="comms-carousel">
        <div className="talk-header">
          <h1 className={isDark ? "dark-mode" : ""}>{commsData.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode talk-header-subtitle"
                : "subTitle talk-header-subtitle"
            }
          >
            {commsData.subtitle}
          </p>
        </div>

        <div
          className="talks-container"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          {commsData.talks.map((talk, index) => (
            <div
              key={index}
              className={`talk-card ${isDark ? "dark-mode" : ""}`}
              style={{
                opacity: getOpacity(index),
                transform: index === currentSlide ? "scale(1)" : "scale(.85)",
                display: getOpacity(index) > 0 ? "block" : "none",
                width: getCardWidth(index)
              }}
            >
              <div className="talk-image">
                <img
                  src={talk.image}
                  alt={talk.title}
                  className="image-comms-event"
                  loading="lazy"
                />
              </div>
              <div className="talk-details">
                <h3 className={isDark ? "dark-mode card-title" : "card-title"}>
                  {talk.title}
                </h3>
                <p
                  className={
                    isDark ? "dark-mode card-description" : "card-description"
                  }
                >
                  {talk.description}
                </p>
                <p
                  className={
                    isDark ? "dark-mode card-description" : "card-description"
                  }
                >
                  {talk.coauthors}
                </p>
                <p
                  className={
                    isDark ? "dark-mode card-location" : "card-location"
                  }
                >
                  <strong>{talk.location}</strong>
                </p>
              </div>
            </div>
          ))}
          <button
            className="slide-button prev"
            onClick={handlePrevSlide}
            aria-label="Previous Slide"
          >
            <span className="slide-arrow">&#8249;</span>
          </button>
          <button
            className="slide-button next"
            onClick={handleNextSlide}
            aria-label="Next Slide"
          >
            <span className="slide-arrow">&#8250;</span>
          </button>
        </div>
      </div>
    </Fade>
  );
}
